import { render, staticRenderFns } from "./DeliveryNotice.vue?vue&type=template&id=e9432e22&scoped=true&"
import script from "./DeliveryNotice.vue?vue&type=script&lang=js&"
export * from "./DeliveryNotice.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryNotice.vue?vue&type=style&index=0&id=e9432e22&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9432e22",
  null
  
)

export default component.exports